import { render } from "./Footer.vue?vue&type=template&id=3fa8c6ec"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"
script.render = render

export default script